import useSwr from 'swr'

export const useTopArticles = (category) => {
  let url = '/jsonapi/v1/articles?page[limit]=5&sort=random'
  if (category) {
    url += `&filter[category]=${category}`
  }
  const { data, error } = useSwr(url)
  const topArticles = data?.filter(
    (item) => item.heroImage && item.heroImage.url,
  )

  return {
    topArticles,
    error,
  }
}
